module.exports = __webpack_public_path__ + "img/line-of-credit.701ba7dd.svg";